var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3306 24.5043L11.685 15.72C11.4954 15.5283 11.389 15.2696 11.389 15C11.389 14.7304 11.4954 14.4716 11.685 14.28L20.3288 5.49558C20.5183 5.30273 20.6245 5.04316 20.6245 4.77277C20.6245 4.50238 20.5183 4.24281 20.3288 4.04996C20.2362 3.95499 20.1255 3.87952 20.0033 3.82799C19.8811 3.77646 19.7498 3.74991 19.6172 3.74991C19.4846 3.74991 19.3533 3.77646 19.2311 3.82799C19.1089 3.87952 18.9982 3.95499 18.9056 4.04996L10.2619 12.8325C9.6939 13.4109 9.37567 14.1893 9.37567 15C9.37567 15.8107 9.6939 16.589 10.2619 17.1675L18.9056 25.95C18.9982 26.0452 19.109 26.1209 19.2314 26.1726C19.3538 26.2243 19.4853 26.251 19.6181 26.251C19.751 26.251 19.8825 26.2243 20.0049 26.1726C20.1272 26.1209 20.238 26.0452 20.3306 25.95C20.5201 25.7571 20.6263 25.4975 20.6263 25.2271C20.6263 24.9568 20.5201 24.6972 20.3306 24.5043Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ec8cde086848c4d08f2f52cc4eae9f32.svg";
export { ForwardRef as ReactComponent };